import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
export function LiveViewers() {
  const [visible, setVisible] = useState(false);
  const [viewers, setViewers] = useState(101);
  // Reveal the bar once the user starts navigating (scrolling) the page.
  // Detach the listener as soon as it fires — it only needs to run once.
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 120) {
        setVisible(true);
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  // Gently fluctuate the count so it feels live (stays near 101).
  useEffect(() => {
    const id = setInterval(() => {
      setViewers(prev => {
        const delta = Math.floor(Math.random() * 5) - 2; // -2..+2
        const next = prev + delta;
        return Math.min(128, Math.max(94, next));
      });
    }, 3200);
    return () => clearInterval(id);
  }, []);
  return <AnimatePresence data-id="element-148">
      {visible && <motion.div initial={{
      opacity: 0,
      y: -12,
      x: 12
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: -12
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed right-3 top-24 z-[60] flex items-center gap-2.5 rounded-full border border-white/10 bg-ink-900/90 px-3.5 py-2 shadow-card backdrop-blur-md sm:right-5 sm:top-28" data-id="element-149">
          <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true" data-id="element-150">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" data-id="element-151" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" data-id="element-152" />
          </span>
          <EyeIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-153" />
          <p className="text-xs font-semibold text-white sm:text-sm" data-id="element-154">
            <span className="tabular-nums text-accent-light" data-id="element-155">{viewers}</span>{' '}
            <span className="text-silver/70" data-id="element-156">personas viendo ahora</span>
          </p>
        </motion.div>}
    </AnimatePresence>;
}